import { Component, EventEmitter, inject, input, Input, OnInit, output, Output } from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';
import { ErrorIconComponent } from 'remarketing-ui-components-lib';
import { Subject } from 'rxjs';
import { Configuration, ConfigurationState } from 'remarketing-angular-library';
import { select, Store } from '@ngxs/store';
import { takeUntil } from 'rxjs/operators';
import { SaComponent } from 'smartauction-frontend-micro-library';

@Component({
  selector: 'app-action-list-error-modal',
  imports: [TranslocoDirective, ErrorIconComponent],
  templateUrl: './action-list-error-modal.component.html',
  styleUrl: './action-list-error-modal.component.scss'
})
export class ActionListErrorModalComponent extends SaComponent {

  public readonly errorMessage$ = input<string>();

  public readonly close = output();
  public readonly error = output<string>();

  protected readonly configuration$ = select(ConfigurationState.configuration);

  constructor() {
    super();
  }

  closeModal() {
    this.close.emit();
  }
}
